function newGuid(): string {
    return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
              const r = (Math.random() * 16) | 0
              const v = c === 'x' ? r : (r & 0x3) | 0x8
              return v.toString(16)
          })
}

export class QualityControlSoilResultTest {
    id = ''
    reportId = '00000000-0000-0000-0000-000000000000'
    sortOrder = 0
    testNo = ''
    testDate: string | Date | null = ''
    testMode = ''
    elevation = ''
    location = ''
    depthIn = ''
    waterContentPct = ''
    wetDensityPcf = ''
    dryDensityPcf = ''
    maxDensityPcf = ''
    compactionPct = ''
    requiredPct = ''
    passFail = ''
    comments = ''
}

export class QualityControlSoilResult {
    id!: string
    job!: string
    reportSource = ''
    labName = ''
    reportNumber = ''
    inspector = ''
    serviceDate = ''
    reportDate = ''
    generalLocation = ''
    testMethod = ''
    gaugeMake = ''
    gaugeModel = ''
    gaugeSerial = ''
    gaugeCalibrationDate = ''
    standardCountDensity = ''
    standardCountMoisture = ''
    proctorNo = ''
    soilDescription = ''
    maxDryDensityPcf = ''
    optimumMoisturePct = ''
    requiredCompactionPct = ''
    projectSpecification = ''
    weather = ''
    remarks = ''
    startTime = ''
    stopTime = ''
    standardHours = ''
    overtimeHours = ''
    travelHours = ''
    createdOn!: Date
    modifiedOn!: Date
    tests: QualityControlSoilResultTest[] = []

    static createNew(): QualityControlSoilResult {
        const record = new QualityControlSoilResult()
        record.id = newGuid()
        record.tests = []
        return record
    }
}
